import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Youtube, Instagram, Facebook, Menu } from 'lucide-react';
import { Button } from './ui/button';
import MobileMenu from './MobileMenu';
import { useSettings } from '../contexts/SettingsContext';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { settings } = useSettings();

  return (
    <header className="fixed top-0 w-full z-50 bg-black">
      {/* Top Bar - Hidden on mobile */}
      <div className="bg-black border-b border-gray-800 hidden lg:block">
        <div className="container mx-auto px-6 py-2 flex justify-end items-center text-sm">
          <div className="flex items-center gap-4">
            <div className="flex gap-3">
              {settings?.social_youtube && (
                <a href={settings.social_youtube} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Youtube size={18} />
                </a>
              )}
              {settings?.social_instagram && (
                <a href={settings.social_instagram} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Instagram size={18} />
                </a>
              )}
              {settings?.social_twitter && (
                <a href={settings.social_twitter} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <svg className="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
              )}
              {settings?.social_facebook && (
                <a href={settings.social_facebook} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Facebook size={18} />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="bg-black">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center group">
            <div className="text-white font-bold text-2xl tracking-wider transition-all duration-300 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-[#FDB714] group-hover:via-[#f59e0b] group-hover:to-[#ef4444]">
              {settings?.site_name || 'Cinefora Sinemaları'}
            </div>
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <Link to="/vizyondaki-filmler" className="nav-link text-gray-300 hover:text-white transition-all duration-300 text-sm font-medium relative group">
              Vizyondakiler
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#FDB714] via-[#f59e0b] to-[#ef4444] group-hover:w-full transition-all duration-300"></span>
            </Link>
            <Link to="/yakinda" className="nav-link text-gray-300 hover:text-white transition-all duration-300 text-sm font-medium relative group">
              Yakında
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#8b5cf6] via-[#a855f7] to-[#ec4899] group-hover:w-full transition-all duration-300"></span>
            </Link>
            <Link to="/kampanyalar" className="nav-link text-gray-300 hover:text-white transition-all duration-300 text-sm font-medium relative group">
              Kampanyalar
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#a855f7] to-[#ec4899] group-hover:w-full transition-all duration-300"></span>
            </Link>
            <Link to="/haberler" className="nav-link text-gray-300 hover:text-white transition-all duration-300 text-sm font-medium relative group">
              Haberler
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#3b82f6] via-[#8b5cf6] to-[#ec4899] group-hover:w-full transition-all duration-300"></span>
            </Link>
            <Link to="/salonlarimiz" className="nav-link text-gray-300 hover:text-white transition-all duration-300 text-sm font-medium relative group">
              Salonlarımız
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#10b981] to-[#f59e0b] group-hover:w-full transition-all duration-300"></span>
            </Link>
            <Link to="/iletisim" className="nav-link text-gray-300 hover:text-white transition-all duration-300 text-sm font-medium relative group">
              İletişim
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#FDB714] to-[#ef4444] group-hover:w-full transition-all duration-300"></span>
            </Link>
          </nav>

          <div className="flex items-center gap-4">
            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(true)}
              className="lg:hidden text-white p-2"
            >
              <Menu size={28} />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
    </header>
  );
};

export default Header;
